import React from 'react';
import { SubManager } from '../../classes/SubManager';
import { notification } from '../../services/NotificationService';
import { modal } from '../../services/ModalService';
import { dragging } from '../../services/DragDropService';
/**
 * React Component
 *
 * The AsperaRouteMonitorRender provides a wrapper around frequently updated state items like Modals and Notifications
 *
 * @example
 * ```javascript
 * <AsperaRouteMonitorRender />
 * ```
 */
export class AsperaRouteMonitorRender extends React.Component {
    constructor() {
        super(...arguments);
        this.subManager = new SubManager();
    }
    componentDidMount() {
        this.subManager.setSubscription(notification.notificationNotifier.subscribe({
            next: () => {
                this.setState({});
            },
            error: error => {
                console.error('AsperaRouteMonitorRender: Unable to monitor notifications', error);
            },
        }));
        this.subManager.setSubscription(modal.modalNotifier.subscribe({
            next: () => {
                this.setState({});
            },
            error: error => {
                console.error('AsperaRouteMonitorRender: Unable to monitor modals', error);
            },
        }));
    }
    componentWillUnmount() {
        this.subManager.unsubscribeAll();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "notification-wrapper" }, notification.notificationsToRender.map(item => item)),
            React.createElement("div", { className: "modal-wrapper" }, modal.modalsToRender.map(item => item)),
            React.createElement("div", { className: "drag-wrapper" }, dragging.renderView())));
    }
}
